import { render, staticRenderFns } from "./onlineCard.vue?vue&type=template&id=53895f9a&scoped=true&"
import script from "./onlineCard.vue?vue&type=script&lang=js&"
export * from "./onlineCard.vue?vue&type=script&lang=js&"
import style0 from "./onlineCard.vue?vue&type=style&index=0&id=53895f9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53895f9a",
  null
  
)

export default component.exports